import { render, staticRenderFns } from "./HomeWork.vue?vue&type=template&id=11a6ecb1&scoped=true"
import script from "./HomeWork.vue?vue&type=script&lang=js"
export * from "./HomeWork.vue?vue&type=script&lang=js"
import style0 from "./HomeWork.vue?vue&type=style&index=0&id=11a6ecb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6ecb1",
  null
  
)

export default component.exports